import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import { sizes } from 'style';
import { th } from 'style/theme';
import Avatar from 'products/global/views/Profile/components/CustomizeAvatar/components/Avatar';

export const AvatarOptionsWrapper = styled(motion.div)`
  height: auto;
  padding-bottom: 50px;
  width: 90%;
  max-width: 500px;
  margin: 18px auto 0 auto;

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
  grid-auto-rows: minmax(min-content, max-content);
  grid-gap: 15px;

  @media ${sizes.desktop} {
    height: 100%;
    width: 86%;
    max-width: 100%;
    grid-gap: 28px 24px;
    padding: 6px;
    padding-bottom: 6px;
    margin: 0 0 0 auto;
  }
`;

export const AvatarOption = styled.div`
  position: relative;

  ::before {
    content: '';
    display: block;
    padding-top: 113%;
  }
`;

export const Content = styled.div`
  background-color: ${({ isSelected }) =>
    isSelected ? th('colors.white') : th('colors.transparentWhite.4')};
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  border-radius: 10px;
  transition: 0.2s;
  height: 100%;
  width: 100%;

  :hover {
    background-color: ${th('colors.white')};
  }

  @media ${sizes.desktop} {
    border-radius: 8px;
  }

  ${({ withBackground, background }) =>
    withBackground &&
    css`
      background-color: ${background};
      box-shadow: ${th('shadows.small')};

      :hover {
        background-color: ${background};

        @media ${sizes.desktop} {
          opacity: 0.8;
        }
      }
    `}
`;

export const Indicator = styled.div`
  box-shadow: inset 0px 0px 0px 3px ${th('colors.white')};
  visibility: ${({ isSelected }) => (isSelected ? 'visible' : 'hidden')};
  border-radius: 10px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  @media ${sizes.desktop} {
    border-radius: 8px;
  }
`;

export const StyledAvatar = styled(Avatar)`
  width: ${({ withTop }) => (withTop ? '48%' : '45%')};
  margin-bottom: 8%;
`;
